<template>
    <el-cascader
            :disabled="disabled"
            @input="handleChange"
            :value="value"
            :options="options"
            :props="props"
    ></el-cascader>
</template>

<script>
    export default {
        name: "CmsCategorySelect",
        props: {
            value: {
                type: String,
                default: ''
            },
            flag: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                options: [],
                props: {
                    label: 'name',
                    value: 'code',
                    emitPath: false,
                    checkStrictly: true
                }
            }
        },
        methods: {
            handleChange(e) {
                if (e) this.$emit('input', e);
            }
        },
        async created() {
            let res = await this.$http.post(this.$api.cmsCategory.tree);
            if (res.data.status === 200) {
                this.options = res.data.data.tree;
                this.options.forEach((e)=>{
                     if(e.flag === this.flag){
                         this.$emit('input',e.code);
                     }
                })
                this.$forceUpdate()
            }
        }
    }
</script>

<style scoped>

</style>